/* eslint @typescript-eslint/naming-convention: 0 */
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export interface SearchExperienceByThemeParams {
  search_theme: string;
}

const buildSearchExperienceByThemeParams = (themes: string[]): SearchExperienceByThemeParams => {
  const joinedThemes = themes.sort().join(',');
  return { search_theme: joinedThemes };
};

/**
 * 発火タイミング：検索発火時
 * @param themes カンマ区切りのテーマの文字列
 * @returns
 */
export const sendGAWabunkaSearchExperienceByThemeEvent = (themes: string) => {
  if (themes === '') {
    return;
  }
  sendWabunkaGAEvent('search_experience_by_theme', buildSearchExperienceByThemeParams(themes.split(',')));
};
